import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

const width = '259px';

export const Root = styled.div(props => {
  const { typography } = ThemeHelper.getTheme(props);

  return `
    min-width: ${width};
    max-width: ${width};
    font-family: ${typography.family};
    font-size: 14px;
    left: 0;
    background-color: white;
    z-index: 4;
    overflow: hidden;
    position: -webkit-sticky;
    position: sticky;
    border-bottom: 15px solid transparent;
`;
});

export const HeaderContainer = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid ${colours.grey[400]};
    border-left: none;
    border-top: none;
    background-color: white;
    height: 46px;
    width: ${width};
  `;
});

export const StudentListItemWrapper = styled.div`
  margin-top: 0.01px;
`;



// WEBPACK FOOTER //
// ./components/student-list/styled.js